import { gql } from '@apollo/client';
export const getDocumentQuery = gql `
  query GetDocument($documentId: ID!) {
    document: fileSystemDocument(id: $documentId) {
      id
      htmlBody
    }
  }
`;
